import { render, staticRenderFns } from "./HalfDetail.vue?vue&type=template&id=cb6d769e&scoped=true"
import script from "./HalfDetail.vue?vue&type=script&lang=js"
export * from "./HalfDetail.vue?vue&type=script&lang=js"
import style0 from "./HalfDetail.vue?vue&type=style&index=0&id=cb6d769e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6d769e",
  null
  
)

export default component.exports